import React, {Component} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'




class SelectRadioGroup2 extends Component {

    /*componentWillMount() {
     this.props.getAnimals();
     }*/

    constructor(props) {
        super(props);
        this.renderInputs = this.renderInputs.bind(this);
    }

    renderInputs() {
        return this.props.configSelectRadioGroup.infoSelect.map((info, index) => {
            return (
                <div key={index}>
                    <label className={"custom-control custom-checkbox custom-solid-checkbox custom-solid-checkbox-info"}>
                        <input type="checkbox" className={"form-check-input"} value={info.value}
                               onClick={(e) => this.props.configSelectRadioGroup.methodChange(info.value)}/>
                        {/*<span className={"custom-control-indicator"}></span>*/}
                        <span className={"custom-control-description"}>
                            {info.faIcon && <FontAwesomeIcon icon={info.faIcon} color={info.colorIcon}/>}
                            {" "+info.label}</span>
                    </label>
                </div>
            );
        });
    }

    render() {
        return (
            <div>
                    { this.props.configSelectRadioGroup.showLabel &&
                    <label htmlFor={this.props.configSelectRadioGroup.mainId}>{this.props.configSelectRadioGroup.mainLabel}</label>
                    }
                    <div id={this.props.configSelectRadioGroup.mainId} className={"form-group"}>
                        {this.renderInputs()}
                    </div>
            </div>
        );
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.configSelectRadioGroup.selected !== undefined && this.props.configSelectRadioGroup.selected.length !== 0) {
            this.props.configSelectRadioGroup.selected.forEach((sel) => {
                $("#"+ this.props.configSelectRadioGroup.mainId + " input[value='"+sel+"']").prop("checked", true);
            })
        }else{
            this.props.configSelectRadioGroup.infoSelect.forEach((sel) => {
                $("#"+ this.props.configSelectRadioGroup.mainId + " input[value='"+sel.value+"']").prop("checked", false);
            })
        }
    }
    
    componentDidMount() {
        if (this.props.configSelectRadioGroup.selected !== undefined && this.props.configSelectRadioGroup.selected.length !== 0) {
            this.props.configSelectRadioGroup.selected.forEach((sel) => {
                $("#"+ this.props.configSelectRadioGroup.mainId + " input[value='"+sel+"']").prop("checked", true);
            })
        }else{
            this.props.configSelectRadioGroup.infoSelect.forEach((sel) => {
                $("#"+ this.props.configSelectRadioGroup.mainId + " input[value='"+sel.value+"']").prop("checked", false);
            })
        }
    }

}


//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default SelectRadioGroup2
